import { invert } from 'lodash-es';
import { IntlShape } from 'react-intl';
import messages from './messages.json';

export const categoryParametersToCategory: Record<string, string> = {
  'design-and-creative': 'Design & Creative',
  internships: 'Internships',
  other: 'Other',
  'product-and-supply-chain': 'Product & Supply Chain',
  'retail-management-and-in-store': 'Retail Management & In-store',
  'sales-and-marketing': 'Sales & Marketing',
};

export const categoryNames = Object.values(categoryParametersToCategory);

export const categoriesToCategoryParameters = invert(
  categoryParametersToCategory,
);

export const originalCategoryParameters = Object.keys(
  categoryParametersToCategory,
);

export const getLocalizedCategory = (
  intl: IntlShape,
  category: string,
) => intl.formatMessage(
  messages[
    `jobs.category.${categoriesToCategoryParameters[category]}.label`
  ],
);

export const getLocalizedCategoryParameter = (
  intl: IntlShape,
  originalCategoryParameter: string,
) => intl.formatMessage(
  messages[
    `jobs.category.${originalCategoryParameter}.param`
  ],
);

export const getLocalizedCategoryParameterByCategory = (
  intl: IntlShape,
  category: string,
) => intl.formatMessage(
  messages[
    `jobs.category.${categoriesToCategoryParameters[category]}.param`
  ],
);

export const getLocalizedCategoryParameters = (
  intl: IntlShape,
) => Object.fromEntries(
  originalCategoryParameters
    .map((originalCategoryParameter) => [
      getLocalizedCategoryParameter(intl, originalCategoryParameter),
      originalCategoryParameter,
    ]),
);
